import React, { useEffect, useState } from "react";
import ContentBox from "../ContentBox/ContentBox";
import { Chip, Grid, IconButton, SelectChangeEvent, Stack, TextField, Typography } from "@mui/material";
import ButtonLoading from "../Button/ButtonLoading";
import _ from "lodash";
import { Add } from "@mui/icons-material";
import ApiClient from "../../services/ApiClient";
import { AttachmentFilter as AttachmentFilterType } from "../../types/AttachmentFilter.ts";
import MenuItem from "@mui/material/MenuItem";
import LabeledSelect from "../Select/LabeledSelect.tsx";

export default function AttachmentFilter() {
  const [isLoading, setIsLoading] = useState(true);
  const [filterType, setFilterType] = useState("email");
  const [filters, setFilters] = useState<string[]>([]);
  const [registryEntryIri, setRegistryEntryIri] = useState("");
  const [initialFilters, setInitialFilters] = useState<string[]>([]);
  const [newFilter, setNewFilter] = useState("");

  useEffect(() => {
    fetchFilters(filterType);
  }, []);

  const handleSaveFilters = () => {
    setIsLoading(true);

    const payload = {
      registryValue: JSON.stringify(filters),
    };

    ApiClient.patch(registryEntryIri, { body: JSON.stringify(payload) }).then(() => {
      setIsLoading(false);
    });
  };

  const handleFilterTypeChange = async (e: SelectChangeEvent) => {
    setFilterType(e.target.value);
    await fetchFilters(e.target.value);
  };

  const fetchFilters = async (filterType: string) => {
    const resultCollection = await ApiClient.get(`registry_entries?registryKey=${filterType}AttachmentFilters`);
    const entry: AttachmentFilterType = _.head(resultCollection["hydra:member"])!;
    setRegistryEntryIri(entry["@id"]);
    const filters = entry["registryValue"];
    const sortedResult = _.sortBy(JSON.parse(filters));
    setInitialFilters(sortedResult);
    setFilters(sortedResult);
    setIsLoading(false);
  };

  const removeFilter = (filterToRemove: string) => {
    setFilters(_.filter(filters, (filter) => filter !== filterToRemove));
  };

  const addFilter = () => {
    setFilters(_.sortBy([...filters, newFilter]));
    setNewFilter("");
  };

  return (
    <ContentBox>
      <LabeledSelect
        label={"Anhangstyp"}
        value={filterType}
        onChange={handleFilterTypeChange}
        sx={{ marginBottom: "1rem" }}
      >
        <MenuItem value={"email"}>Email</MenuItem>
        <MenuItem value={"bea"}>beA</MenuItem>
      </LabeledSelect>
      <Typography>
        Hier bitte die Wörter eingeben, nach denen unser System Anhänge ausfiltern soll. Anhänge die diese Wörter im
        Namen enthalten, sind dann nicht mehr im Anlagen-Tool sichtbar.
        <br />
        <br />
        Beispiel: pruefvermerk, vermerk_pruefung, prüfvermerk, .jpg
      </Typography>
      <Grid container sx={{ margin: "1rem 0" }} spacing={2}>
        {_.map(filters, (filter, index) => (
          <Grid key={index}>
            <Chip onDelete={() => removeFilter(filter)} label={filter} variant={"outlined"} />
          </Grid>
        ))}
      </Grid>
      <Stack
        direction={"row"}
        spacing={2}
        sx={{
          justifyContent: "center",
          alignItems: "center",
        }}
      >
        <TextField
          placeholder={"Filterwort"}
          value={newFilter}
          onChange={(event) => setNewFilter(event.target.value)}
        />
        <IconButton disabled={newFilter === ""} onClick={addFilter}>
          <Add />
        </IconButton>
      </Stack>
      <ButtonLoading
        onClick={handleSaveFilters}
        isLoading={isLoading}
        variant={"contained"}
        disabled={_.isEqual(filters, initialFilters)}
      >
        Speichern
      </ButtonLoading>
    </ContentBox>
  );
}
